// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-snapshot-container {
  display: inline-grid;
  grid-template-rows: 1fr 50px;
  width: 100%;
  box-sizing: border-box;
}
.create-snapshot-container .create-snapshot-fields {
  display: inline-flex;
  flex-direction: column;
  row-gap: 10px;
}
.create-snapshot-container .create-snapshot-fields .create-snapshot-input {
  height: 100px;
  border: 1px solid #ccc;
  background-color: #FFFFFF;
  border-radius: 5px;
  padding: 6px;
  margin-bottom: 10px;
  outline: none;
  resize: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/Settings/DBSnapshots/CreateSnapshot/CreateSnapshot.scss"],"names":[],"mappings":"AAAA;EACC,oBAAA;EACA,4BAAA;EACA,WAAA;EACA,sBAAA;AACD;AACC;EACC,oBAAA;EACA,sBAAA;EACA,aAAA;AACF;AACE;EACC,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;AACH","sourcesContent":[".create-snapshot-container {\n\tdisplay: inline-grid;\n\tgrid-template-rows: 1fr 50px;\n\twidth: 100%;\n\tbox-sizing: border-box;\n\n\t.create-snapshot-fields {\n\t\tdisplay: inline-flex;\n\t\tflex-direction: column;\n\t\trow-gap: 10px;\n\n\t\t.create-snapshot-input {\n\t\t\theight: 100px;\n\t\t\tborder: 1px solid #ccc;\n\t\t\tbackground-color: #FFFFFF;\n\t\t\tborder-radius: 5px;\n\t\t\tpadding: 6px;\n\t\t\tmargin-bottom: 10px;\n\t\t\toutline: none;\n\t\t\tresize: none;\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
